import type { components } from '@connected/api-client/api.generated';

import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export type RisoMeasurement = components['schemas']['ListElectricalProjectRisoMeasurementQueryResultMeasurement'];

export type UseRisoMeasurementsOptions = {
    electricalProjectVersionId: string;
    distributionBoardDeviceId: string;
};

export function useRisoMeasurements({ electricalProjectVersionId, distributionBoardDeviceId }: UseRisoMeasurementsOptions) {
    if (!electricalProjectVersionId) {
        throw new Error('electricalProjectVersionId is required');
    }

    if (!distributionBoardDeviceId) {
        throw new Error('distributionBoardDeviceId is required');
    }

    const risoMeasurements = useSuspenseQuery(elektraAppQueryOptions.project.risoMeasurementOptions({
        electricalProjectVersionId,
    }));

    const filteredMeasurements = useMemo(() => risoMeasurements.data?.Measurements?.filter(risoMeasurement => risoMeasurement.ElectricalProjectDistributionBoardDeviceId === distributionBoardDeviceId) || [], [risoMeasurements.data?.Measurements, distributionBoardDeviceId]);

    return {
        data: {
            measurements: filteredMeasurements as RisoMeasurement[],
            count: filteredMeasurements.length,
        },
        isLoading: risoMeasurements.isLoading,
        isError: risoMeasurements.isError,
        error: risoMeasurements.error,
    };
}
